/**
 * Was unter einem Projekt steht: wie viel drin ist, und wann zuletzt. (22.09.2026)
 *
 * Martin zur Projekte-Uebersicht, mit Foto: *„Designtechnisches
 * ueberarbeiten, bitte auch mit Zeitstempelangabe und vielleicht auch die
 * Anzeige der Anzahl der Dokumente und die aktualisierte Version."*
 *
 * ⚠️ EINE Zeile, keine drei Abzeichen. Die Karte traegt schon Name und
 *    Beschreibung; weitere Kaestchen daneben machen eine Uebersicht
 *    unuebersichtlicher, nicht klarer.
 *
 * ⚠️ Und nichts wird erfunden. Ein Projekt ohne Verknuepfungen sagt „noch
 *    nichts verknuepft" statt „0 Dokumente" — null ist hier kein Messwert,
 *    sondern ein Zustand. Ohne Aenderungsdatum steht das Anlegedatum da,
 *    mit dem Wort, das dazugehoert: „angelegt", nicht „geaendert".
 */

interface ProjektMetaQuelle {
  linkCount?: number;
  updatedAt?: string | null;
  createdAt?: string | null;
}

/** Wie viele Dinge haengen dran — in Worten. */
export function mengeText(n: number): string {
  if (n <= 0) return "noch nichts verknüpft";
  return `${n} ${n === 1 ? "Dokument" : "Dokumente"}`;
}

/**
 * Die ganze Zeile. `zeitText` kommt von aussen, damit diese Entscheidung
 * ohne Uhr pruefbar bleibt.
 */
export function projektMeta(
  p: ProjektMetaQuelle,
  zeitText: (iso: string) => string,
): string {
  const teile = [mengeText(p.linkCount ?? 0)];
  if (p.updatedAt) {
    teile.push(`geändert ${zeitText(p.updatedAt)}`);
  } else if (p.createdAt) {
    teile.push(`angelegt ${zeitText(p.createdAt)}`);
  }
  return teile.join("  ·  ");
}
